import { Component } from "@angular/core";
import { MatTabChangeEvent } from "@angular/material/tabs";
// import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from "@angular/router";
import { values } from "lodash";
import { lastValueFrom } from "rxjs";
import { environment } from "src/environments/environment";
import { AlertService } from "src/services/alert.service";
import { ApiService } from "src/services/api.service";
import { CommonService } from "src/services/common.service";
import { UtilityService } from "src/services/utility.service";

@Component({
  selector: "app-user-profile",
  templateUrl: "./user-profile.component.html",
  styleUrls: ["./user-profile.component.scss"],
})
export class UserProfileComponent {
  userId: string = "";
  limit = 12;
  totalCount = 0;
  currentPage = 0;
  selectedTabIndex = 0;
  userDetails: any = {};
  socialLinks: { type: string; url: string }[] = [];
  leaderboardData: any = {};
  relatedDatasets = [];
  relatedUsecase = [];
  relatedModels = [];
  page = 0;
  readonly environment = environment;
  statsDetails = [
    {
      label: "Datasets",
      subLabel: "Uploded",
      count: 0,
      key: "datasetCount",
      index: 1,
      icon: "assets/images/dataset_userpro.svg",
      event: "",
    },
    {
      label: "Models",
      subLabel: "Uploded",
      count: 0,
      key: "modelCount",
      index: 2,
      icon: "assets/images/model_user.svg",
      event: "",
    },
    {
      label: "Use Cases",
      subLabel: "Uploded",
      count: 0,
      key: "usecaseCount",
      index: 3,
      icon: "assets/images/usecase_user.svg",
      event: "",
    },
    {
      label: "Toolkits",
      subLabel: "Uploded",
      count: 0,
      key: "toolkitCount",
      index: 4,
      icon: "assets/images/toolkit_user.svg",
      event: "",
    },
    {
      label: "Total Received Upvotes",
      subLabel: "Across all artefacts",
      count: 0,
      key: "totalReceivedUpvotes",
      icon: "assets/images/upvotes_user.svg",
      event: "",
    },
    {
      label: "Total Profile Views",
      subLabel: "Unique Views",
      count: 0,
      key: "totalProfileViews",
      icon: "assets/images/unique_view.svg",
      event: "",
    },
  ];
  mileStone: number[] = [];

  constructor(
    private router: Router,
    private commonService: CommonService,
    private apiService: ApiService,
    // private dialog: MatDialog,
    private alertService: AlertService,
    private utilityService: UtilityService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.userId = this.route.snapshot.params["userId"];
    this.selectedTabIndex = +this.route.snapshot.queryParams["tabIndex"] || 0;
    this.fetchUserDetails();
    this.fetchTabsData();
  }

  fetchTabsData() {
    switch (this.selectedTabIndex) {
      case 0:
        this.fetchUserStatsDetails();
        this.fetchUserLeaderBoard();
        return;
      case 1:
        this.fetchDatasetList();
        return;
      case 2:
        this.fetchModelList();
        return;
      case 3:
        this.fetchUsecaseList();
        return;
      // case 4:
      // fetch toolkit
    }
  }

  async fetchDatasetList() {
    const res = await lastValueFrom(
      this.apiService.getDataSetListWeb([
        { key: "current_owner", value: this.userId },
        { key: "page", value: this.currentPage + 1 },
        { key: "size", value: this.limit },
      ])
    );
    this.totalCount = res?.data?.cards?.total || 0;
    this.relatedDatasets = res?.data?.cards?.data;
  }

  async fetchModelList() {
    const res = await lastValueFrom(
      this.apiService.getModelListWeb([
        { key: "current_owner", value: this.userId },
        { key: "page", value: this.currentPage + 1 },
        { key: "size", value: this.limit },
      ])
    );
    this.totalCount = res?.data?.cards?.total || 0;
    this.relatedModels = res?.data?.cards?.data;
  }

  async fetchUsecaseList() {
    const res = await lastValueFrom(
      this.apiService.getUsecaseListWeb([
        { key: "userId", value: this.userId },
        { key: "page", value: this.currentPage + 1 },
        { key: "size", value: this.limit },
      ])
    );
    this.totalCount = res?.data?.cards?.total || 0;
    this.relatedUsecase = res?.data?.cards?.data;
  }
  async fetchUserDetails() {
    const iconLink: Record<string, string> = {
      linkedIn: "assets/images/linkedin.svg",
      twitterX: "assets/images/twitter-x-blue.svg",
      facebook: "assets/images/facebook.svg",
      gitHub: "assets/images/github.svg",
    };

    try {
      const res = await lastValueFrom(
        this.apiService.getUserProfileData(this.userId)
      );
      this.userDetails = res?.data;

      this.socialLinks = Object.keys(iconLink)
        .filter((key) => !!this.userDetails?.[key])
        .map((key) => ({
          type: iconLink[key],
          url: this.userDetails[key],
        }));
    } catch (err) {
      console.error("Error fetching user details:", err);
    }
  }

  async fetchUserLeaderBoard() {
    try {
      const res = await lastValueFrom(
        this.apiService.getUserProfileStatsLeaderBoard(this.userId)
      );
      this.leaderboardData = res?.data?.data[0];
      this.setMileStone();
    } catch (err) {
      console.log(err);
    }
  }

  setMileStone() {
    const milestones = [5, 20, 50, 100, 500];
    const total = this.leaderboardData?.totalPublished || 0;

    this.mileStone = milestones.filter((m) => m <= total);
  }

  async fetchUserStatsDetails() {
    try {
      const res = await lastValueFrom(
        this.apiService.getUserProfileStats(this.userId)
      );

      this.statsDetails = this.statsDetails?.map((item) => {
        return { ...item, count: res?.data?.[item?.key] || 0 };
      });
    } catch (err) {
      console.log(err);
    }
  }

  onStatsCardClick(event: any) {
    if (event?.index) {
      this.onTabChange(event);
    }
  }

  onImageAvtrError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = "assets/images/avatar.jpg";
  }

  onTabChange(event: MatTabChangeEvent) {
    this.selectedTabIndex = event.index;
    this.router.navigate([`admin/user/user-profile/${this.userId}`], {
      queryParams: {
        tabIndex: this.selectedTabIndex,
      },
    });
    this.currentPage = 0;
    this.limit = 12;
    this.fetchTabsData();
  }

  pageChanged(event: any) {
    this.limit = event.pageSize;
    this.currentPage = event.pageIndex;
    this.fetchTabsData();
  }
}
